import { useState, useCallback, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BalanceContext } from '../contexts';
import { APP_NAME } from '../config';
import CurrencyIcon from './CurrencyIcon';

const Container = styled.div`
	min-height: 100vh;
	background: ${props => props.theme.background};
	padding: 0 16px;
	box-sizing: border-box;
`;

const Header = styled.div`
	text-align: center;
	margin-bottom: 40px;
`;

const Title = styled.h1`
	font-size: 24px;
	font-weight: 700;
	color: ${props => props.theme.text.primary};
	margin: 0 0 16px 0;
	text-align: center;
`;

const Subtitle = styled.p`
	font-size: 1.2rem;
	color: ${props => props.theme.text.secondary};
	margin-bottom: 20px;
`;

const TokenSection = styled.div`
	position: relative;
	width: 200px;
	height: 200px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 40px;
`;

const Token = styled.div`
	font-size: 80px;
	cursor: pointer;
	transition: transform 0.2s ease;
	user-select: none;

	&:active {
		transform: scale(0.9);
	}
`;

const Particle = styled.div`
	position: absolute;
	width: 10px;
	height: 10px;
	background: ${props => props.color || '#ffd700'};
	border-radius: 50%;
	pointer-events: none;
`;

const HintText = styled.p`
	font-size: 1rem;
	color: ${props => props.theme.text.secondary};
	text-align: center;
`;

const TokenFarming = () => {
	const [particles, setParticles] = useState([]);
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { balance, updateBalance } = useContext(BalanceContext);

	useEffect(() => {
		return () => {
			setParticles([]);
		};
	}, []);

	// Обработка клика по токену
	const handleTokenClick = useCallback((e) => {
		console.log('Token clicked');
		const rect = e.currentTarget.getBoundingClientRect();
		const centerX = rect.width / 2;
		const centerY = rect.height / 2;

		// Создаем несколько частиц в разных позициях вокруг токена
		const particlePositions = [
			{ x: centerX - 20, y: centerY },
			{ x: centerX + 20, y: centerY },
			{ x: centerX, y: centerY - 20 },
			{ x: centerX, y: centerY + 20 },
		];

		const newParticles = particlePositions.map((pos, index) => ({
			id: Date.now() + index,
			x: pos.x,
			y: pos.y,
			color: `hsl(${Math.random() * 360}, 70%, 50%)`,
		}));

		setParticles(prev => [...prev, ...newParticles]);

		// Обновляем баланс
		updateBalance(prev => prev + 1);

		// Удаляем частицы через 1 секунду
		setTimeout(() => {
			setParticles(prev => prev.filter(p => !newParticles.some(np => np.id === p.id)));
		}, 1000);
	}, [updateBalance]);

	return (
		<Container>
			<Header>
				<Title>{APP_NAME} {t('currency_title')}</Title>
				<Subtitle>Кликай и зарабатывай токены</Subtitle>
			</Header>

			<TokenSection>
				<Token onClick={handleTokenClick}><CurrencyIcon size={80} /></Token>
				{particles.map(particle => (
					<Particle
						key={particle.id}
						style={{
							left: `${particle.x}px`,
							top: `${particle.y}px`,
							backgroundColor: particle.color,
						}}
					/>
				))}
			</TokenSection>

			<HintText>Нажимай на токен, чтобы заработать</HintText>
		</Container>
	);
};

export default TokenFarming; 